import { Component, AfterViewInit } from '@angular/core'

@Component({
  selector: 'cm-ad',
  templateUrl: './ad.component.html',
  styleUrls: ['./ad.component.css']
})
export class AdComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit() {
    setTimeout(() => {
      try {
        console.log('Ad init');
        (adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {
        console.error('Ad error')
      }
    }, 10)
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/ad/ad.component.ts